// Presentation-only allowlist of frozen candidate paths; no grid reconstruction.
const family=n=>n.split('').sort().join('');
function gridExplanation(pick){
 const e=pick.frozenEvidence;
 if(!e||!Number.isInteger(e.pathCount)||e.pathCount<1||!Array.isArray(e.paths)||e.paths.length!==e.pathCount)return null;
 const paths=e.paths.map(p=>{
  if(!p||!Array.isArray(p.cells)||p.cells.length!==3||typeof p.straight!=='string'||!/^\d{3}$/.test(p.straight)||family(p.straight)!==pick.family)return null;
  if(p.cells.some((c,i)=>!c||c.column!==i||typeof c.digit!=='string'||!/^\d$/.test(c.digit)))return null;
  const digits=p.cells.map(c=>c.digit);
  return digits.join('')===p.straight?{digits}:null;
 });
 if(paths.some(p=>p===null))return null;
 // Match the saved best-path identifier privately; never show that identifier.
 const best=e.paths.findIndex(p=>p.id===e.bestPath&&p.straight===pick.straight);
 return {pathCount:e.pathCount,paths,chosen:best>=0?paths[best]:null};
}
function gridVisualEvidence(pick,stored){
 const ranked=pick?.frozenEvidence;
 if(ranked?.selectionTier==='strategy_ranked'&&Array.isArray(ranked.sourceGrid)){
  if(stored?.rows?.length!==3||ranked.sourceGrid.length!==3||!Array.isArray(ranked.paths)||!ranked.paths.length)return null;
  const rows=stored.rows;
  if(rows.some((r,i)=>!Array.isArray(r.digits)||r.digits.length!==3||r.digits.some(d=>!/^\d$/.test(d))||r.date!==ranked.sourceGrid[i]?.source?.date||r.session!==ranked.sourceGrid[i]?.source?.session||r.digits.join('')!==ranked.sourceGrid[i]?.source?.number))return null;
  const paths=ranked.paths.map(p=>{if(!/^\d{3}$/.test(p.straight||'')||family(p.straight)!==pick.family||p.rows?.length!==3||p.rows.some((r,c)=>!Number.isInteger(r)||r<0||r>2||rows[r].digits[c]!==p.straight[c]))return null;return {digits:[...p.straight],rows:p.rows.slice()};});
  if(paths.some(p=>!p))return null;const chosen=paths.find(p=>p.digits.join('')===pick.straight);if(!chosen)return null;
  return {rows:rows.map(r=>({digits:r.digits.slice(),date:r.date,session:r.session})),paths,chosen,pathCount:paths.length};
 }

 const basic=gridExplanation(pick),e=pick.frozenEvidence;
 if(!basic||!basic.chosen||!Array.isArray(stored?.rows)||stored.rows.length!==3)return null;
 const rows=stored.rows;
 if(rows.some(r=>!Array.isArray(r.digits)||r.digits.length!==3||r.digits.some(d=>typeof d!=='string'||!/^\d$/.test(d))))return null;
 const paths=e.paths.map((p,i)=>{
  if(!Array.isArray(p.rows)||p.rows.length!==3||p.rows.some((r,c)=>!Number.isInteger(r)||r<0||r>2||rows[r].digits[c]!==basic.paths[i].digits[c]))return null;
  return {digits:basic.paths[i].digits,rows:p.rows.slice()};
 });
 if(paths.some(p=>!p))return null;
 const best=e.paths.findIndex(p=>p.id===e.bestPath&&p.straight===pick.straight);
 return {rows:rows.map(r=>({digits:r.digits.slice(),date:r.date,session:r.session})),paths,chosen:paths[best],pathCount:basic.pathCount};
}
module.exports={gridExplanation,gridVisualEvidence};

